// extracted by mini-css-extract-plugin
module.exports = {"text-tiny":"11px","link":"NavigationTab-module--link--88cdd6","active":"NavigationTab-module--active--0dba98","single":"NavigationTab-module--single--345ae3"};